import {Button, Icon, Text} from '#component/base';
import {FullscreenModalHeader} from '#component/partial';
import {sprinkles} from '#style/sprinkles';

import {EmptyPageProps} from './EmptyPage.types';

export const EmptyPage = ({
  body,
  ctaProps,
  headline = 'Oh no!',
  iconName = 'Warning',
}: EmptyPageProps) => (
  <>
    <FullscreenModalHeader
      className={sprinkles({pY: 12})}
      buttonVariant="secondary-dark"
      logoColor="cotton"
    />

    <div className={sprinkles({flex: 'flex', dir: 'col', grow: 1})}>
      <div
        className={sprinkles({
          content: 'center',
          dir: 'col',
          flex: 'flex',
          gap: 32,
          grow: [1, 0],
          mT: [0, 'auto'],
        })}>
        <Icon color="tangerine" name={iconName} size={74} weight="light" />

        <div className={sprinkles({flex: 'flex', dir: 'col', gap: 16})}>
          <Text color="tangerine" variant="label">
            Weekly Check-Ins
          </Text>

          <Text as="h1" color="cotton" variant="heading1">
            {headline}
          </Text>
        </div>

        <Text as={typeof body === 'string' ? 'p' : 'div'} color="cotton">
          {body}
        </Text>
      </div>

      <div className={sprinkles({pT: 32, mB: [0, 'auto']})}>
        <Button as="a" variant="primary-dark" {...ctaProps} />
      </div>
    </div>
  </>
);
